<!--SUMMARY OPTIONS SET AS DEFAULT BUTTON-->
<div style="margin-top: 3%;">
  <app-result-set-config-btn *ngIf="optsConf"
                             [resultSetConfig]="optsConf"
                             (toggleChangeNotifier)="onResultSetDefaultChange(ResultSetIDEnum.DETAILED_SUMMARY_OPTS)"
  >
  </app-result-set-config-btn>
</div>
<!--END SET AS DEFAULT BUTTON-->
<!--START SELECTION BOXES-->
<div class="row flex-row">

  <!-- Category Select -->
  <div class="flex-item dropdown-container">
    <mat-form-field floatLabel="never" class="anessa-dropdown">
      <mat-select
        id="baseline-detailed-category_select"
        [(value)]="categorySet"
        disableOptionCentering
        (valueChange)="setTableData(); unsetDefaults(ResultSetIDEnum.DETAILED_SUMMARY_OPTS)"
        panelClass="anessa-dropdown-panel">
        <mat-option
          *ngFor="let opt of categoriesOptions"
          [value]="opt">{{ opt | anessaTranslation: trigger }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Result Select -->
  <div class="flex-item dropdown-container">
    <mat-form-field floatLabel="never" class="anessa-dropdown">
      <mat-select
        id="baseline-detailed-result_select"
        multiple
        disableOptionCentering
        [placeholder]="'RESULTS.GENERAL.SELECT_RESULTS' | anessaTranslation: trigger"
        [disabled]="displayOptions.length === 0"
        panelClass="anessa-dropdown-panel">
        <mat-option>
          <ngx-mat-select-search
            [placeholderLabel]="'RESULTS.GENERAL.SEARCH' | anessaTranslation: trigger"
            [noEntriesFoundLabel]="'RESULTS.ERRORS.NO_RESULTS' | anessaTranslation: trigger"
            class="clear-search"
            ngModel
            (ngModelChange)="filterDisplayOptions($event); unsetDefaults(ResultSetIDEnum.DETAILED_SUMMARY_OPTS)">
            <i ngxMatSelectSearchClear class="material-icons">
              delete
            </i>
          </ngx-mat-select-search>
        </mat-option>
        <div class="dropdown-select-all-container">
          <mat-checkbox
            class="mat-option mat-option-multi"
            color="primary"
            (change)="optionChanged(optionsRoot, $event); unsetDefaults(ResultSetIDEnum.DETAILED_SUMMARY_OPTS)"
            [checked]="optionsRoot.status === 'checked'"
            [indeterminate]="optionsRoot.status === 'indeterminate'"
            #inputsCheckbox>
            {{ inputsCheckbox.checked ?
            ('RESULTS.GENERAL.DESELECT_ALL' | anessaTranslation: trigger) :
            ('RESULTS.GENERAL.SELECT_ALL' | anessaTranslation: trigger) }}
          </mat-checkbox>
        </div>
        <ng-container *ngFor="let option of displayOptions">
          <mat-option *ngIf="showDisplayOption(option)"
                      class="select-filter-option tree-select-option"
                      [ngClass]="{'filter-matched': option.filterMatched}">
            <pre>{{' '.repeat(2 * (option.depth - 1))}}</pre>
            <mat-checkbox
              class="mat-option mat-option-multi"
              color="primary"
              [ngClass]="{
                'checked-leaf': option.isLeaf && option.status === 'checked',
                'unchecked-leaf': option.isLeaf && option.status === 'unchecked'
              }"
              (change)="optionChanged(option, $event); unsetDefaults(ResultSetIDEnum.DETAILED_SUMMARY_OPTS)"
              [checked]="option.status === 'checked'"
              [indeterminate]="option.status === 'indeterminate'">
              {{ option.label | anessaTranslation: trigger }}
            </mat-checkbox>
          </mat-option>
        </ng-container>
      </mat-select>
      <mat-label *ngIf="displayOptions.length === 0">
        <div class="select-placeholder-container">
          <span>{{'RESULTS.SUMMARY.LOADING' | anessaTranslation: trigger}}</span>
          <mat-spinner class="spinner" diameter="20"></mat-spinner>
        </div>
      </mat-label>
    </mat-form-field>
  </div>

  <!-- Currency Select -->
  <div class="flex-item dropdown-container">
    <mat-form-field floatLabel="never" class="anessa-dropdown">
      <mat-select
        id="baseline-detailed-currency_select"
        [(value)]="currencySet"
        placeholder="{{'RESULTS.GENERAL.SET_CURRENCY' | anessaTranslation: trigger}}"
        disableOptionCentering
        [disabled]="currencyOptions.length === 0"
        (valueChange)="setTableData(); unsetDefaults(ResultSetIDEnum.DETAILED_SUMMARY_OPTS)"
        panelClass="anessa-dropdown-panel">
        <mat-option
          *ngFor="let opt of currencyOptions"
          [value]="opt">{{ opt.translationId | anessaTranslation: trigger }}
        </mat-option>
      </mat-select>
      <mat-label *ngIf="currencyOptions.length === 0">
        <div class="select-placeholder-container">
          <span>{{'RESULTS.SUMMARY.LOADING' | anessaTranslation: trigger}}</span>
          <mat-spinner class="spinner" diameter="20"></mat-spinner>
        </div>
      </mat-label>
    </mat-form-field>
  </div>

  <!-- Measurement System Select -->
  <div class="flex-item dropdown-container">
    <mat-form-field floatLabel="never" class="anessa-dropdown">
      <mat-select
        id="baseline-detailed-measurement_select"
        [(value)]="measurementSet"
        placeholder="{{'RESULTS.GENERAL.SET_UNIT_TYPE' | anessaTranslation: trigger }}"
        disableOptionCentering
        (valueChange)="updateRNGProducts(); setTableData(); unsetDefaults(ResultSetIDEnum.DETAILED_SUMMARY_OPTS)"
        panelClass="anessa-dropdown-panel">
        <mat-option
          *ngFor="let opt of measurementOptions"
          [value]="opt">{{ opt | anessaTranslation: trigger }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

</div>

<div>
  <p>{{'RESULTS.GENERAL.EXCHANGE_RATES_FROM' | anessaTranslation: trigger}} <i>{{ exchangeRateDate }}</i></p>
</div>

<!--END SELECTION BOXES-->
<div *ngIf="categorySet === 'RESULTS.SUMMARY.ALL' || categorySet ===  'RESULTS.SUMMARY.INPUTS'">
  <h1>{{ 'RESULTS.SUMMARY.PROJECT_INPUTS' | anessaTranslation: trigger }}</h1>
  <!-- Inputs table -->
  <results-treetable #treetableInputs
                     [inputsData]="inputsData"
                     [firstColumnHeader]="'RESULTS.SUMMARY.INPUTS' | anessaTranslation: trigger"
                     [hideSaveButtons]="true"
                     [currencyUnit]="currencySet"
                     [measurement]="measurementSet"
  ></results-treetable>
</div>


<div *ngIf="categorySet === 'RESULTS.SUMMARY.ALL' || categorySet ===  'RESULTS.SUMMARY.OUTPUTS'">
  <h1>{{ 'RESULTS.SUMMARY.SIMULATION_RESULTS' | anessaTranslation: trigger }}</h1>
  <!-- Period Select -->
  <!--PERIOD OPTIONS SET AS DEFAULT BUTTON-->
  <div>
    <app-result-set-config-btn *ngIf="periodConf"
                               [resultSetConfig]="periodConf"
                               (toggleChangeNotifier)="onResultSetDefaultChange(ResultSetIDEnum.DETAILED_SUMMARY_PERIOD)"
    >
    </app-result-set-config-btn>
  </div>
  <div *ngIf="treetableValueUnitResults.tree.length > 0" class="row flex-row">
    <div class="flex-item">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          id="baseline-detailed-period_select"
          [(value)]="periodSet"
          (valueChange)="unsetDefaults(ResultSetIDEnum.DETAILED_SUMMARY_PERIOD)"
          disableOptionCentering
          panelClass="anessa-dropdown-panel">
          <mat-option
            *ngFor="let opt of periodOptions"
            [value]="opt">{{ opt | anessaTranslation: trigger }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <!-- outputs table, value and unit format -->
  <results-treetable #treetableValueUnitResults
    [resultsData]="outputsData"
    [firstColumnHeader]="'RESULTS.SUMMARY.OUTPUTS' | anessaTranslation: trigger"
    [hideSaveButtons]="true"
    [dataFormat]="'value_unit'"
    [currencyUnit]="currencySet"
    [measurement]="measurementSet"
    [period]="periodSet"
  ></results-treetable>
</div>

<!-- outputs table, yearly format -->
<div *ngIf="categorySet === 'RESULTS.SUMMARY.ALL' || categorySet ===  'RESULTS.SUMMARY.OUTPUTS'">
  <results-treetable #treetableYearlyResults
                     [resultsData]="outputsData"
                     [firstColumnHeader]="'RESULTS.SUMMARY.OUTPUTS' | anessaTranslation: trigger"
                     [hideSaveButtons]="true"
                     [hideOnlyZeros]="true"
                     [dataFormat]="'yearly'"
                     [currencyUnit]="currencySet"
                     [measurement]="measurementSet"
                     [groupAggregationMethod]="aggregationMethods.SUM"
                     [aggregationWhiteList]="['RESULTS.DATA.ISPL.REVENUES', 'RESULTS.DATA.ISPL.EXPENSES',
                     'RESULTS.DATA.CASHFLOWS.CFOA', 'RESULTS.DATA.CASHFLOWS.CFIA', 'RESULTS.DATA.CASHFLOWS.CFFA']"
  ></results-treetable>
</div>

<div class="results-container">
  <div class="item" >
    <button mat-button
            class="btn-green first-layer-button"
            (click)="saveToPdf()"
    >{{'RESULTS.SUMMARY.SAVE_TO_PDF' | anessaTranslation: trigger}}
    </button>
  </div>
  <div class="item">
    <button
      mat-button
      class="btn-green first-layer-button"
      (click)="saveToExcel()"
    >{{'RESULTS.SUMMARY.SAVE_TO_EXCEL' | anessaTranslation: trigger}}
    </button>
  </div>
</div>
